<template>
  <div id="container" v-if="fetch_data">
    <section id="shop">
      <div class="wrap">
        <div class="register_step flex">
          <div class="step_box flex on">
            <div class="num">1</div>
            <p>お届け先の<br class="sp">入力</p>
          </div>
          <div class="step_box flex">
            <div class="num">2</div>
            <p>ご注文内容の<br class="sp">確認</p>
          </div>
          <div class="step_box flex">
            <div class="num">3</div>
            <p>決済情報の<br class="sp">入力</p>
          </div>
          <div class="step_box flex">
            <div class="num">4</div>
            <p>ご注文を<br class="sp">受け付けました</p>
          </div>
        </div>

        <div class="cts_box form">
          <h2 class="sub_ttl"><span>お届け先の入力</span></h2>
          <h3 class="min_ttl">ご注文内容</h3>
          <div class="cart_box">
            <div class="cart_item flex" v-for="article in fetch_data.shopping.articles"
                 v-bind:key="article.article.id">
              <div class="image"><img v-bind:src="article.article.image_files[0]" alt=""></div>
              <div class="cart_cts">
                <h3 class="item_ttl">{{ article.article.title }}</h3>
                <p class="price">¥ {{ delimited(article.price) }}</p>
                <template v-if="false">
                  <div class="tagbox" v-if="article.article.point_usable"><span class="tag">ポイント払い可能</span></div>
                  <div class="tagbox" v-else><span class="tag">ポイント払い不可</span></div>
                </template>
                <div class="point">ポイント：<span>3%</span>（ポイント利用分には付与されません）</div>
                <div class="item_count flex">
                  <p>数量: {{ article.count }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="cart_all flex">
            <div class="count_all">カートの合計（{{ delimited(fetch_data.shopping_count) }}点の商品）（税込）：</div>
            <div class="price_all">¥ {{ delimited(fetch_data.total_price) }}</div>
          </div>
        </div>

        <div class="cts_box mb20 anchor_point" id="form">
          <form @submit="update">
            <h3 class="min_ttl">ご購入者様情報</h3>
            <p class="lead_txt">
              下記フォームに必要事項をご入力の上、画面下の「ご注文内容の確認」ボタンを押してください。<br>
              <span class="blue bold">「*」のついている箇所は必須項目です。</span>
            </p>

            <div class="msg_box error" v-if="errors">
              <h3>ご入力内容にエラー項目があります</h3>
              <p>エラー個所は赤く表示され、エラー理由がすぐ下に赤字で示されます。<br>お手数ですが、エラー項目を修正してからボタンを押してください。</p>
            </div>

            <div>
              <div class="input_set name">
                <div class="label">おなまえ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓</div>
                    <input type="text" maxlength="16" placeholder="例：山田" v-model="session.last_name"
                           @input="session.last_name = replaceHalfToFull(session.last_name)"
                           v-bind:class="{error: validation_session_errors.last_name}">
                    <ValidationErrors :errors="validation_session_errors.last_name" v-if="validation_session_errors.last_name"/>
                  </div>
                  <div class="field">
                    <div class="label">名</div>
                    <input type="text" maxlength="16" placeholder="例：太郎" v-model="session.first_name"
                           @input="session.first_name = replaceHalfToFull(session.first_name)"
                           v-bind:class="{error: validation_session_errors.first_name}">
                    <ValidationErrors :errors="validation_session_errors.first_name" v-if="validation_session_errors.first_name"/>
                  </div>
                </div>
              </div>

              <div class="input_set kana">
                <div class="label">フリガナ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓（全角カナ）</div>
                    <input type="text" maxlength="16" placeholder="例：ヤマダ" v-model="session.last_name_kana"
                           @input="session.last_name_kana = replaceHiraToKana(session.last_name_kana)"
                           v-bind:class="{error: validation_session_errors.last_name_kana}">
                    <ValidationErrors :errors="validation_session_errors.last_name_kana"
                                      v-if="validation_session_errors.last_name_kana"/>
                  </div>
                  <div class="field">
                    <div class="label">名（全角カナ）</div>
                    <input type="text" maxlength="16" placeholder="例：タロウ" v-model="session.first_name_kana"
                           @input="session.first_name_kana = replaceHiraToKana(session.first_name_kana)"
                           v-bind:class="{error: validation_session_errors.first_name_kana}">
                    <ValidationErrors :errors="validation_session_errors.first_name_kana"
                                      v-if="validation_session_errors.first_name_kana"/>
                  </div>
                </div>
              </div>

              <div class="input_set email">
                <div class="label">連絡先メールアドレス<span>*</span></div>
                <input type="email" v-model="session.email"
                       @input="session.email = replaceFullToHalf(session.email)"
                       v-bind:class="{error: validation_session_errors.email}">
                <ValidationErrors :errors="validation_session_errors.email" v-if="validation_session_errors.email"/>
              </div>

              <div class="input_set email">
                <div class="label">連絡先メールアドレス（確認）<span>*</span></div>
                <input type="email" v-model="session.email_confirmation"
                       @input="session.email_confirmation = replaceFullToHalf(session.email_confirmation)"
                       v-bind:class="{error: validation_session_errors.email_confirmation}">
                <ValidationErrors :errors="validation_session_errors.email_confirmation"
                                  v-if="validation_session_errors.email_confirmation"/>
              </div>

              <div class="input_set phone">
                <div class="label">連絡先電話番号<span>*</span></div>
                <p>（半角数字で日中連絡の取れるお電話番号をご入力下さい。）</p>
                <input type="tel" v-model="session.phone_number"
                       @input="session.phone_number = replaceFullToHalf(session.phone_number)"
                       v-bind:class="{error: validation_session_errors.phone_number}" placeholder="例：09012345678"
                       value="09012345678">
                <ValidationErrors :errors="validation_session_errors.phone_number" v-if="validation_session_errors.phone_number"/>
              </div>

              <div class="input_set addr">
                <div class="label">郵便番号<span>*</span></div>
                <p>（半角数字）</p>
                <div class="input_fields flex">
                  <div class="field">
                    <input type="text" v-model="session.zip" v-bind:class="{error: validation_session_errors.zip}"
                           @input="session.zip = replaceFullToHalf(session.zip)"
                           name="zip"
                           placeholder="例：100-1234">
                    <validation-errors :errors="validation_session_errors.zip"
                                       v-if="validation_session_errors.zip"></validation-errors>
                  </div>
                  <div class="field">
                    <button type="button" class="ajaxzip3" v-on:click="optZipSearch">郵便番号から住所を取得</button>
                  </div>
                </div>
              </div>

              <div class="input_set addr">
                <div class="label">都道府県名<span>*</span></div>
                <p>（選択して下さい ※海外には配送できません）</p>
                <PrefectureSelect :prefecture="session.prefecture" :only_japan="true" name="prefecture"
                                  v-bind:class="{error: validation_session_errors.prefecture}"
                                  v-on:changed="optPrefectureChanged"/>
                <validation-errors :errors="validation_session_errors.prefecture"
                                   v-if="validation_session_errors.prefecture"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">市区町村<span>*</span></div>
                <input type="text" v-model="session.address1" v-bind:class="{error: validation_session_errors.address1}"
                       @input="session.address1 = replaceHalfToFull(session.address1)"
                       placeholder="例：新宿区">
                <validation-errors :errors="validation_session_errors.address1"
                                   v-if="validation_session_errors.address1"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">地名・番地<span>*</span></div>
                <input type="text" v-model="session.address2" v-bind:class="{error: validation_session_errors.address2}"
                       @input="session.address2 = replaceHalfToFull(session.address2)"
                       class="address" placeholder="例：３丁目１３番地">
                <validation-errors :errors="validation_session_errors.address2"
                                   v-if="validation_session_errors.address2"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">建物名・部屋番号<span></span></div>
                <input type="text" v-model="session.address3" v-bind:class="{error: validation_session_errors.address3}"
                       @input="session.address3 = replaceHalfToFull(session.address3)"
                       class="addr4" placeholder="例：複眼ビル１１１号室">
                <validation-errors :errors="validation_session_errors.address3"
                                   v-if="validation_session_errors.address3"></validation-errors>
              </div>

              <div class="input_set mt20">
                <div class="label">備考欄</div>
                <textarea name="" placeholder="" v-bind:class="{error: validation_errors.memo}"
                          v-model="shopping.memo" maxlength="124"></textarea>
                <ValidationErrors :errors="validation_errors.memo"
                                  v-if="validation_errors.memo"></ValidationErrors>
              </div>
            </div>

            <div class="radio mt20">
              <input id="radio01" type="radio" name="mailing_add" v-model="shopping.send_user_address"
                     @click="sendUserAddress()" value="1">
              <label for="radio01">ご購入者様の住所にお届けする</label><br>
              <input id="radio02" type="radio" name="mailing_add" v-model="shopping.send_user_address"
                     @click="sendOtherAddress()" value="0">
              <label for="radio02">送り先を指定する</label>
            </div>

            <div v-show="shopping.send_user_address === 0 || shopping.send_user_address === '0'">
              <h3 class="min_ttl">送り先情報</h3>
              <div class="input_set name">
                <div class="label">おなまえ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓</div>
                    <input type="text" maxlength="16" placeholder="例：山田" v-model="shopping.last_name"
                           @input="shopping.last_name = replaceHalfToFull(shopping.last_name)"
                           v-bind:class="{error: validation_errors.last_name}">
                    <ValidationErrors :errors="validation_errors.last_name" v-if="validation_errors.last_name"/>
                  </div>
                  <div class="field">
                    <div class="label">名</div>
                    <input type="text" maxlength="16" placeholder="例：太郎" v-model="shopping.first_name"
                           @input="shopping.first_name = replaceHalfToFull(shopping.first_name)"
                           v-bind:class="{error: validation_errors.first_name}">
                    <ValidationErrors :errors="validation_errors.first_name" v-if="validation_errors.first_name"/>
                  </div>
                </div>
              </div>

              <div class="input_set kana">
                <div class="label">フリガナ<span>*</span></div>
                <div class="input_fields flex">
                  <div class="field">
                    <div class="label">姓（全角カナ）</div>
                    <input type="text" maxlength="16" placeholder="例：ヤマダ" v-model="shopping.last_name_kana"
                           @input="shopping.last_name_kana = replaceHiraToKana(shopping.last_name_kana)"
                           v-bind:class="{error: validation_errors.last_name_kana}">
                    <ValidationErrors :errors="validation_errors.last_name_kana"
                                      v-if="validation_errors.last_name_kana"/>
                  </div>
                  <div class="field">
                    <div class="label">名（全角カナ）</div>
                    <input type="text" maxlength="16" placeholder="例：タロウ" v-model="shopping.first_name_kana"
                           @input="shopping.first_name_kana = replaceHiraToKana(shopping.first_name_kana)"
                           v-bind:class="{error: validation_errors.first_name_kana}">
                    <ValidationErrors :errors="validation_errors.first_name_kana"
                                      v-if="validation_errors.first_name_kana"/>
                  </div>
                </div>
              </div>

              <div class="input_set phone">
                <div class="label">電話番号<span>*</span></div>
                <p>（半角数字）</p>
                <input type="tel" v-model="shopping.phone_number"
                       @input="shopping.phone_number = replaceFullToHalf(shopping.phone_number)"
                       v-bind:class="{error: validation_errors.phone_number}" placeholder="例：09012345678"
                       value="09012345678">
                <ValidationErrors :errors="validation_errors.phone_number" v-if="validation_errors.phone_number"/>
              </div>

              <div class="input_set addr">
                <div class="label">郵便番号<span>*</span></div>
                <p>（半角数字）</p>
                <div class="input_fields flex">
                  <div class="field">
                    <input type="text" v-model="shopping.zip" v-bind:class="{error: validation_errors.zip}"
                           @input="shopping.zip = replaceFullToHalf(shopping.zip)"
                           name="zip"
                           placeholder="例：100-1234">
                    <validation-errors :errors="validation_errors.zip"
                                       v-if="validation_errors.zip"></validation-errors>
                  </div>
                  <div class="field">
                    <button type="button" class="ajaxzip3" v-on:click="zipSearch">郵便番号から住所を取得</button>
                  </div>
                </div>
              </div>

              <div class="input_set addr">
                <div class="label">都道府県名<span>*</span></div>
                <p>（選択して下さい ※海外には配送できません）</p>
                <PrefectureSelect :prefecture="shopping.prefecture" :only_japan="true" name="prefecture"
                                  v-bind:class="{error: validation_errors.prefecture}"
                                  v-on:changed="prefectureChanged"/>
                <validation-errors :errors="validation_errors.prefecture"
                                   v-if="validation_errors.prefecture"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">市区町村<span>*</span></div>
                <input type="text" v-model="shopping.address1" v-bind:class="{error: validation_errors.address1}"
                       @input="shopping.address1 = replaceHalfToFull(shopping.address1)"
                       placeholder="例：新宿区">
                <validation-errors :errors="validation_errors.address1"
                                   v-if="validation_errors.address1"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">地名・番地<span>*</span></div>
                <input type="text" v-model="shopping.address2" v-bind:class="{error: validation_errors.address2}"
                       @input="shopping.address2 = replaceHalfToFull(shopping.address2)"
                       class="address" placeholder="例：３丁目１３番地">
                <validation-errors :errors="validation_errors.address2"
                                   v-if="validation_errors.address2"></validation-errors>
              </div>

              <div class="input_set addr">
                <div class="label">建物名・部屋番号<span></span></div>
                <input type="text" v-model="shopping.address3" v-bind:class="{error: validation_errors.address3}"
                       @input="shopping.address3 = replaceHalfToFull(shopping.address3)"
                       class="addr4" placeholder="例：複眼ビル１１１号室">
                <validation-errors :errors="validation_errors.address3"
                                   v-if="validation_errors.address3"></validation-errors>
              </div>
            </div>

            <div class="cts_box">
              <div class="btnBox mb40">
                <p class="alnC mb10">すべての項目の入力が完了しましたら<br class="sp">こちらのボタンを押してください。</p>
                <button type="submit" class="submit light arrow">ご注文内容の確認</button>
              </div>

              <div class="btnBox">
                <p class="alnC mb10">カートの中身を変更する場合は<br class="sp">こちらのボタンを押してください。</p>
                <a @click="$router.go(-1)" class="submit light skeleton arrow back">前のページにもどる</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>

  </div>
</template>

<script>

import Libraries from '@/components/Libraries'
import ValidationErrors from "@/components/ValidationErrors";
import PrefectureSelect from "@/components/PrefectureSelect";

export default {
  mixins: [Libraries],
  components: {
    ValidationErrors,
    PrefectureSelect,
  },
  data() {
    return {
      fetch_data: null,
      shopping: null,
      session: null,
      validation_errors: {},
      validation_session_errors: {},
      errors: null,
    }
  },
  mounted() {
    // form token
    this.setFormToken('Shopping')

    if (this.isUserSignedIn()) {
      // 会員なら会員用のお届け先ページへ
      this.$router.push({name: 'ShoppingRegister'})
    } else {
      this.fetchData()
    }
  },
  methods: {
    pointPercent(article) {
      return article.add_points * 100 / article.price;
    },

    sendUserAddress() {
      this.validation_errors = {}
      this.shopping.phone_number = this.session.phone_number
      this.shopping.last_name = this.session.last_name
      this.shopping.first_name = this.session.first_name
      this.shopping.last_name_kana = this.session.last_name_kana
      this.shopping.first_name_kana = this.session.first_name_kana
      this.shopping.zip = this.session.zip
      this.shopping.prefecture = this.session.prefecture
      this.shopping.address1 = this.session.address1
      this.shopping.address2 = this.session.address2
      this.shopping.address3 = this.session.address3
    },

    sendOtherAddress() {
      this.validation_errors = {}
      this.shopping.phone_number = ''
      this.shopping.last_name = ''
      this.shopping.first_name = ''
      this.shopping.last_name_kana = ''
      this.shopping.first_name_kana = ''
      this.shopping.zip = ''
      this.shopping.prefecture = ''
      this.shopping.address1 = ''
      this.shopping.address2 = ''
      this.shopping.address3 = ''
    },

    fetchData() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}shop/shopping.json`)
          .then(response => {
            this.fetch_data = response.data
            this.shopping = response.data.shopping
            this.session = response.data.million_session
            this.session.email_confirmation = this.session.email
            if (this.fetch_data.shopping_count === 0) {
              this.$router.push({name: 'ShoppingArticles'})
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },

    prefectureChanged(prefecture) {
      this.shopping.prefecture = prefecture
      //this.$forceUpdate()
    },
    zipSearch() {
      if (this.shopping.zip) {
        this.addressSearch(this.shopping.zip)
            .then(data => {
              this.shopping.prefecture = data.pref
              this.shopping.address1 = data.address
              this.$forceUpdate()
            })
      }
    },

    optPrefectureChanged(prefecture) {
      this.session.prefecture = prefecture
      //this.$forceUpdate()
    },
    optZipSearch() {
      if (this.session.zip) {
        this.addressSearch(this.session.zip)
            .then(data => {
              this.session.prefecture = data.pref
              this.session.address1 = data.address
              this.$forceUpdate()
            })
      }
    },

    update(event) {
      event.preventDefault()

      this.shopping.email = this.session.email
      this.shopping.email_confirmation = this.session.email
      if (Number(this.shopping.send_user_address) === 1) {
        this.sendUserAddress()
      }

      this.axios
          .post(`${this.env.api_base_url}shop/update_shopping_non_member.json`, {
            user_shopping: this.shopping,
            million_session: this.session
          })
          .then(() => {
            this.$router.push({name: 'ShoppingPayment'})
          })
          .catch((error) => {
            this.scrollTo('#form')
            if (error.response.data.errors || error.response.data.validation_session_errors) {
              this.validation_errors = error.response.data.validation_errors
              this.validation_session_errors = error.response.data.validation_session_errors
              this.errors = true
            }
          })
          .finally(() => {
            this.finishAjax()
          })
    }
  }
}
</script>
